export const ParentDomainList = [
  "sumoordering.com",
  "www.sumoordering.com",
  "sostaging.uk",
  "sumoordering.local",
];

export const ChildDomainList = ["sumo.ordering.local"];
